export default {
   path: '/multicotizador/reportes',
   name: 'reportes',
   component: () => import('@/modules/reportes/views/ReportesView.vue'),
};
